import { BlockVariant, DynamicBlock, DynamicBlocks } from '@/components/block-builder/block-builder.types';
import { Injectable } from '@angular/core';

interface getPreDraftDacBlocksProps {
  title?: string;
  save?: () => void;
  history?: () => void;
  rest?: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class DacWorkflowBlocksService {
  getPreDraftDacBlocks = ({ title, save, rest, history }: getPreDraftDacBlocksProps): DynamicBlocks => {
    const saveButton: DynamicBlock = {
      variant: BlockVariant.BUTTON,
      props: {
        label: 'common.save',
        onClick: save,
      },
    };
    const resetButton: DynamicBlock = {
      variant: BlockVariant.BUTTON,
      props: {
        label: 'common.reset',
        onClick: rest,
        severity: 'secondary',
      },
    };

    const historyButton: DynamicBlock = {
      variant: BlockVariant.BUTTON,
      props: {
        label: 'common.history',
        onClick: history,
      },
    };

    return {
      '1': [saveButton],
      '2': [historyButton],
      '3': [resetButton],
    };
  };
}
